import { MonthActions } from "@website/ui/datepicker/components";
import styles from "@website/ui/datepicker/components/flat-header/flat-header.module.scss";
import { HeaderPropertiesType } from "@website/ui/datepicker/components/flat-header/flat-header.types";
import { WEEK_ABBR } from "@website/ui/datepicker/constanst";
import { FC, memo } from "react";

const FlatHeader: FC<HeaderPropertiesType> = (properties) => {
  const {
    calendarLocale = "gregorian",
    showDates,
    scrolled,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled,
    type,
    view
  } = properties;
  return (
    <div
      className={`${styles["header"]} ${styles["rtl" || "ltr"]} ${
        scrolled ? styles["scrolled"] : ""
      }`}
    >
      <MonthActions
        calendarLocale={calendarLocale}
        nextMonthDisabled={nextMonthDisabled}
        previousMonthDisabled={previousMonthDisabled}
        showDates={showDates}
        showNextMonth={showNextMonth}
        showPreviousMonth={showPreviousMonth}
        type={type}
        view={view}
      />
      <div
        className={`${styles["week-names-container-mobile"]} ${
          view === "mobile"
            ? ""
            : styles["week-names-container-mobile__default"]
        }`}
      >
        {[1, 2, 3, 4, 5, 6, 7].map((item) => (
          <div className={styles["week-name"]} key={item}>
            <div className={styles["aspect-ratio-content"]}>
              {WEEK_ABBR[calendarLocale]?.[item - 1] ||
                WEEK_ABBR.gregorian[item - 1]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const HeaderMemoized = memo(FlatHeader);
export { HeaderMemoized as FlatHeader };
